import React from 'react';

export const MarYearModal = {
  title: 'Year',
  body: (
    <div>
      <div>
        Valid values:
        {' '}
        <b>1854 to 1994</b>
      </div>
      <br />
      <p>
        The Date and Time are given in Universal Coordinated Time (also known as Greenwich Mean Time). The local date may be one day different.
      </p>
    </div>
  ),
};
